import { env } from 'utils/env';

export const isProd = env.VITE_APP_ENV === 'prod';
export const isDev = env.VITE_APP_ENV === 'dev';
export const isLocal = env.VITE_APP_ENV === 'local';
export const isDemo = env.VITE_APP_ENV === 'demo';
export const isTest = env.VITE_APP_ENV === 'test';
export enum Environment {
    PROD = 'prod',
    DEV = 'dev',
    LOCAL = 'local',
    DEMO = 'demo',
    TEST = 'stage'
}
